<div class="d-flex flex-column gap-2">

  <!-- ── Imagery date ──────────────────────────────────────────── -->
  @if (propertyData?.capture_date || propertyData?.ortho_date_estimate) {
    <p class="mb-0 text-muted small">
      Property Info based on
      {{ (propertyData?.capture_date || propertyData?.ortho_date_estimate) | date }}
      imagery
    </p>
  }

  <!-- STRUCTURE CARDS -->
  @for (structure of structures; track $index; let i = $index) {
    <lib-structure-card
      [structure]="structure"
      [index]="i + 1"
      [expanded]="i === 0"
      [measurementSystem]="measurementSystem"
      [parcelWkt]="propertyData?.property_features?.parcel_wkt"
      (zoomRequested)="onStructureZoom($event)">
    </lib-structure-card>
  }

  <!-- PROPERTY FEATURES -->
    <mat-expansion-panel class="property-panel" [(expanded)]="expandedPropertyFeatures">
      <mat-expansion-panel-header class="pe-0">
        <mat-panel-title>Property Features</mat-panel-title>
        @if (propertyData.property_features?.parcel_wkt) {
          <mat-panel-description (click)="$event.stopPropagation()">
            <button mat-icon-button [matMenuTriggerFor]="featuresMenu" aria-label="Actions">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu panelClass="actions-menu" #featuresMenu>
              <button mat-menu-item (click)="copyToClipboard(propertyData.property_features.parcel_wkt)">
                <mat-icon>content_copy</mat-icon>
                <span>Copy Parcel</span>
              </button>
              <button mat-menu-item (click)="onParcelZoom()">
                <mat-icon svgIcon="send"></mat-icon>
                <span>Zoom to Parcel</span>
              </button>
            </mat-menu>
          </mat-panel-description>
        }
      </mat-expansion-panel-header>

      <div class="d-flex flex-column">
          <div class="d-flex justify-content-between align-items-center small">
              <span class="text-muted">Total building area</span>
              <span class="text-truncate">{{ formatArea(calculateTotalArea()) }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center small">
              <span class="text-muted">Hardscapes area</span>
              <span>{{ formatArea(propertyData.property_features?.hardscapes?.area) }}</span>
          </div>
          <div class="d-flex justify-content-between align-items-center small">
              <span class="text-muted">Hardscapes</span>
              <div class="bar-row">
                  <mat-progress-bar
                          class="bar-percent"
                          mode="determinate"
                          [value]="propertyData.property_features?.hardscapes?.percent">
                  </mat-progress-bar>
                  <span class="bar-percent-label">{{ propertyData.property_features?.hardscapes?.percent ?? 0 }}%</span>
              </div>
          </div>

          <div class="d-flex justify-content-between align-items-center small">
              <span class="text-muted">Parcel Tree Cover</span>
              <div class="bar-row">
                  <mat-progress-bar
                          class="bar-percent"
                          mode="determinate"
                          [value]="propertyData.property_features.parcel_tree_cover">
                  </mat-progress-bar>
                  <span class="bar-percent-label">{{ propertyData.property_features.parcel_tree_cover ?? 0 }}%</span>
              </div>
          </div>

          @let propertyFeatures = getPropertyFeatures();
          <div class="d-flex justify-content-between align-items-center pt-1">
              <span class="small text-muted fw-semibold">Property Features</span>
              <button mat-button class="mat-button-slim hide-button" (click)="showAllPropertyFeatures = !showAllPropertyFeatures" type="button">
                  {{ showAllPropertyFeatures ? "Hide undetected features" : "Show undetected features" }}
              </button>
          </div>
          @if (!showAllPropertyFeatures && propertyFeatures.length === 0) {
              <div class="no-properties-message" style="font-size: 0.6rem;">No features were detected for this property</div>
          }
        <mat-chip-set>
            @for (chip of propertyFeatures; track chip.label + (chip.type ?? '')) {
                @if (showAllPropertyFeatures || chip.detected) {
                    <mat-chip class="my-0" [class.chip-empty]="!chip.detected">
                        {{ chip.label }}@if (chip.detail) { ({{ chip.detail }})}
                    </mat-chip>
                }
            }
        </mat-chip-set>
      </div>
    </mat-expansion-panel>


  <!-- CONTROLS -->
  <div class="d-flex align-items-center justify-content-between mt-auto pt-2 border-top">
    <div class="d-flex align-items-center">
      <mat-checkbox class="mat-checkbox-slim"
                    [checked]="visibilityValues?.propertyFootprint"
                    (change)="onVisibilityChange('propertyFootprint', $event.checked)"
                    [disabled]="discreteEnabled">
        <span class="small">Footprints</span>
      </mat-checkbox>
      <mat-checkbox class="mat-checkbox-slim"
                    [checked]="visibilityValues?.labelsFootprint"
                    (change)="onVisibilityChange('labelsFootprint', $event.checked)"
                    [disabled]="discreteEnabled">
        <span class="small">Building labels</span>
      </mat-checkbox>
    </div>
    <mat-select [value]="measurementSystem" (valueChange)="onMeasurementSystemChange($event)" class="mat-select-slim" panelClass="mat-select-slim-panel">
      <mat-option [value]="measurementSystems.IMPERIAL">Imperial</mat-option>
      <mat-option [value]="measurementSystems.METRIC">Metric</mat-option>
    </mat-select>
  </div>

</div>
